import { Education } from '~/employee/types/employee.types'
import EmployeeEducation from '~/employee/components/EmployeeEducation'
import EmployeeEducationalDegree from '~/employee/components/EmployeeEducationalDegree'
import EmployeeHeadShot from '~/employee/components/EmployeeHeadShot'

export interface EmployeeCardProps {
  description?: string
  educations?: Education[]
  imageSrcKey: string
  imageAlt?: string
  educationalDegree?: string
  name: string
  showEducations?: boolean
  showEducationalDegree?: boolean
  showDescription?: boolean
  title: string
}

export default function EmployeeCard({
  description,
  educations,
  imageSrcKey,
  imageAlt,
  educationalDegree,
  name,
  showEducations = false,
  showEducationalDegree = false,
  showDescription = false,
  title,
}: EmployeeCardProps): React.ReactElement {
  return (
    <div className="w-80 max-w-full h-min px-8 py-14 flex flex-col justify-between rounded shadow-large bg-gray-off-white">
      <div className="space-y-4">
        <EmployeeHeadShot imageAlt={imageAlt} imageSrcKey={imageSrcKey} />
        <section>
          <div className="text-center text-lg leading-8 font-bold text-black-card" data-testid="employee-card-name">
            {name}
          </div>
          <div className="my-1 text-center text-purple font-semibold" data-testid="employee-card-job-title">
            {title}
          </div>
        </section>
      </div>

      <section>
        {showEducations && educations && educations?.length > 0 && <EmployeeEducation educations={educations} />}
        {showDescription && description && (
          <p className="text-center text-black-light italic" data-testid="employee-card-description">
            {description}
          </p>
        )}
        {showEducationalDegree && educationalDegree && (
          <EmployeeEducationalDegree educationalDegree={educationalDegree} />
        )}
      </section>
    </div>
  )
}
